import { render, staticRenderFns } from "./CoinCustomizationFormV2.vue?vue&type=template&id=736ee9fe&scoped=true&"
import script from "./CoinCustomizationFormV2.vue?vue&type=script&lang=ts&"
export * from "./CoinCustomizationFormV2.vue?vue&type=script&lang=ts&"
import style0 from "./CoinCustomizationFormV2.vue?vue&type=style&index=0&id=736ee9fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ee9fe",
  null
  
)

export default component.exports